__webpack_require__.p = "/kortgo/";